import { render, staticRenderFns } from "./PageUsersCreate.vue?vue&type=template&id=f6e33234&scoped=true&"
import script from "./PageUsersCreate.vue?vue&type=script&lang=ts&"
export * from "./PageUsersCreate.vue?vue&type=script&lang=ts&"
import style0 from "./PageUsersCreate.vue?vue&type=style&index=0&id=f6e33234&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e33234",
  null
  
)

export default component.exports